module.exports = __webpack_public_path__ + "static/media/14UNEP16.d337140f.jpg";